function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "3d-viewer_svg__Union_172",
  width: 25.8,
  height: 28.861,
  x: 0,
  y: 0,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.502
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".3d-viewer_svg__cls-1{fill:#23d3cd}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "3d-viewer_svg__Component_129_3",
  transform: "translate(2.999 3)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#3d-viewer_svg__Union_172)",
  transform: "translate(-3 -3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "3d-viewer_svg__Union_172-2",
  d: "M-1232.992 9489.113l-.007-11.5.015.01 9.674-5.628 10.1 5.624-.069 11.492-9.822 5.734z",
  className: "3d-viewer_svg__cls-1",
  transform: "translate(1236 -9469)"
})), /*#__PURE__*/React.createElement("g", {
  id: "3d-viewer_svg__Component_115_168"
}, /*#__PURE__*/React.createElement("path", {
  id: "3d-viewer_svg__Path_9735",
  d: "M.609 5.628L10.284 0l10.109 5.628-10.109 6.091z",
  className: "3d-viewer_svg__cls-1",
  transform: "translate(-.593)"
}), /*#__PURE__*/React.createElement("path", {
  id: "3d-viewer_svg__Path_9736",
  fill: "#288884",
  d: "M-.005-.187L-.013-11.68l9.908 5.944v11.3z",
  transform: "translate(.013 17.3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "3d-viewer_svg__Path_9737",
  fill: "#24605e",
  d: "M9.825-.175l.069-11.5L0-5.763V5.56z",
  transform: "translate(9.901 17.299)"
})));
function Svg3DViewer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.8,
    height: 28.861,
    viewBox: "0 0 25.8 28.861"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='25.8' height='28.861' viewBox='0 0 25.8 28.861'%3e %3cdefs%3e %3cfilter id='Union_172' width='25.8' height='28.861' x='0' y='0' filterUnits='userSpaceOnUse'%3e %3cfeOffset/%3e %3cfeGaussianBlur result='blur' stdDeviation='1'/%3e %3cfeFlood flood-opacity='.502'/%3e %3cfeComposite in2='blur' operator='in'/%3e %3cfeComposite in='SourceGraphic'/%3e %3c/filter%3e %3cstyle%3e .cls-1%7bfill:%2323d3cd%7d %3c/style%3e %3c/defs%3e %3cg id='Component_129_3' transform='translate(2.999 3)'%3e %3cg filter='url(%23Union_172)' transform='translate(-3 -3)'%3e %3cpath id='Union_172-2' d='M-1232.992 9489.113l-.007-11.5.015.01 9.674-5.628 10.1 5.624-.069 11.492-9.822 5.734z' class='cls-1' transform='translate(1236 -9469)'/%3e %3c/g%3e %3cg id='Component_115_168'%3e %3cpath id='Path_9735' d='M.609 5.628L10.284 0l10.109 5.628-10.109 6.091z' class='cls-1' transform='translate(-.593)'/%3e %3cpath id='Path_9736' fill='%23288884' d='M-.005-.187L-.013-11.68l9.908 5.944v11.3z' transform='translate(.013 17.3)'/%3e %3cpath id='Path_9737' fill='%2324605e' d='M9.825-.175l.069-11.5L0-5.763V5.56z' transform='translate(9.901 17.299)'/%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { Svg3DViewer as ReactComponent };